import { Button, Group, Modal, ScrollArea, Stack, Text } from "@mantine/core";
import type { RecallState } from "../../services/reportDeliveryRecall.service";
import { RecallHistoryAttemptCard } from "./RecallHistoryAttemptCard";

interface ReportDeliveryHistoryModalProps {
  opened: boolean;
  onClose: () => void;
  state: RecallState | undefined;
  caseNumber?: string;
}

export function ReportDeliveryHistoryModal({
  opened,
  onClose,
  state,
  caseNumber,
}: ReportDeliveryHistoryModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Report delivery history"
      size="lg"
      returnFocus
      scrollAreaComponent={ScrollArea.Autosize}
    >
      <Stack gap="md">
        <Text fw={600}>
          {caseNumber ?? "Current case"} • Report version{" "}
          {state?.reportVersion ?? "unavailable"}
        </Text>
        {state?.recallHistory.length ? (
          state.recallHistory.map((attempt) => (
            <RecallHistoryAttemptCard
              key={attempt.attemptId}
              attempt={attempt}
            />
          ))
        ) : (
          <Text c="dimmed">No report recall attempts are recorded.</Text>
        )}
        <Group justify="flex-end">
          <Button
            variant="default"
            onClick={onClose}
            data-autofocus
            style={{ minHeight: 44 }}
          >
            Done
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
